var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parameter-item" }, [
    _c(
      "div",
      { staticClass: "parameter-item__actions" },
      [
        _c("feather-icon", {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: "Editar parámetro",
              expression: "'Editar parámetro'"
            }
          ],
          attrs: { size: "18", icon: "EditIcon", color: "green" },
          on: {
            click: function($event) {
              return _vm.$emit("toggle-edit", !_vm.isEditing)
            }
          }
        }),
        _c("feather-icon", {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: "Eliminar parámetro",
              expression: "'Eliminar parámetro'"
            }
          ],
          attrs: { size: "18", icon: "XCircleIcon", color: "red" },
          on: {
            click: function($event) {
              return _vm.$emit("delete")
            }
          }
        })
      ],
      1
    ),
    !_vm.isEditing
      ? _c("div", { staticClass: "parameter-item__view" }, [
          _c("div", { staticClass: "parameter-item__field" }, [
            _c("span", { staticClass: "parameter-item__label" }, [
              _vm._v("ID:")
            ]),
            _c(
              "span",
              {
                staticClass: "parameter-item__value parameter-item__value--mono"
              },
              [_vm._v(_vm._s(_vm.param.parameter_id))]
            )
          ]),
          _c("div", { staticClass: "parameter-item__field" }, [
            _c("span", { staticClass: "parameter-item__label" }, [
              _vm._v("Nombre:")
            ]),
            _c("span", { staticClass: "parameter-item__value" }, [
              _vm._v(_vm._s(_vm.param.name))
            ])
          ]),
          _c("div", { staticClass: "parameter-item__field" }, [
            _c("span", { staticClass: "parameter-item__label" }, [
              _vm._v("Tipo:")
            ]),
            _c("span", { staticClass: "parameter-item__value" }, [
              _vm._v(_vm._s(_vm.param.type || "text"))
            ])
          ]),
          _vm.param.description
            ? _c(
                "div",
                {
                  staticClass:
                    "parameter-item__field parameter-item__field--full"
                },
                [
                  _c("span", { staticClass: "parameter-item__label" }, [
                    _vm._v("Descripción:")
                  ]),
                  _c("span", { staticClass: "parameter-item__value" }, [
                    _vm._v(_vm._s(_vm.param.description))
                  ])
                ]
              )
            : _vm._e(),
          _vm.param.type === "option"
            ? _c(
                "div",
                {
                  staticClass:
                    "parameter-item__field parameter-item__field--full"
                },
                [
                  _c("ParameterOptionsList", {
                    attrs: { options: _vm.param.options || [], readonly: true }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm.isEditing
      ? _c("div", { staticClass: "parameter-item__edit" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4 col-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Nombre")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localParam.name,
                      expression: "localParam.name"
                    }
                  ],
                  staticClass: "form-control form-control-sm",
                  attrs: { type: "text", placeholder: "Nombre del parámetro" },
                  domProps: { value: _vm.localParam.name },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.localParam, "name", $event.target.value)
                      },
                      _vm.emitUpdate
                    ]
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "col-md-8 col-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Descripción")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localParam.description,
                      expression: "localParam.description"
                    }
                  ],
                  staticClass: "form-control form-control-sm",
                  attrs: {
                    type: "text",
                    placeholder: "Descripción del parámetro"
                  },
                  domProps: { value: _vm.localParam.description },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.localParam,
                          "description",
                          $event.target.value
                        )
                      },
                      _vm.emitUpdate
                    ]
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "col-md-8 col-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Identificador (ID)")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localParam.parameter_id,
                      expression: "localParam.parameter_id"
                    }
                  ],
                  staticClass: "form-control form-control-sm",
                  attrs: { type: "text", placeholder: "Id del parámetro" },
                  domProps: { value: _vm.localParam.parameter_id },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.localParam,
                          "parameter_id",
                          $event.target.value
                        )
                      },
                      _vm.emitUpdate
                    ]
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "col-md-4 col-12" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Tipo")]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.localParam.type,
                        expression: "localParam.type"
                      }
                    ],
                    staticClass: "form-control form-control-sm",
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.localParam,
                            "type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.emitUpdate
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "text" } }, [
                      _vm._v("Texto")
                    ]),
                    _c("option", { attrs: { value: "number" } }, [
                      _vm._v("Numero")
                    ]),
                    _c("option", { attrs: { value: "text-large" } }, [
                      _vm._v("Texto Largo")
                    ]),
                    _c("option", { attrs: { value: "switch" } }, [
                      _vm._v("Y o N")
                    ]),
                    _c("option", { attrs: { value: "option" } }, [
                      _vm._v("Opciones")
                    ]),
                    _c("option", { attrs: { value: "s3-json" } }, [
                      _vm._v("JSON en S3")
                    ]),
                    _c("option", { attrs: { value: "s3-html" } }, [
                      _vm._v("Html en S3")
                    ]),
                    _c("option", { attrs: { value: "s3-text" } }, [
                      _vm._v("Texto en S3")
                    ]),
                    _c("option", { attrs: { value: "s3-xsl" } }, [
                      _vm._v("XSL en S3")
                    ]),
                    _c("option", { attrs: { value: "s3-file" } }, [
                      _vm._v("Archivo en S3")
                    ]),
                    _c("option", { attrs: { value: "s3-image" } }, [
                      _vm._v("Imagen en S3")
                    ]),
                    _c(
                      "option",
                      { attrs: { value: "text-signature-template" } },
                      [_vm._v("Template Firma")]
                    ),
                    _c("option", { attrs: { value: "set" } }, [
                      _vm._v("Set de configuraciones")
                    ])
                  ]
                )
              ])
            ]),
            _vm.localParam.type === "option"
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("ParameterOptionsList", {
                      attrs: { options: _vm.localParam.options || [] },
                      on: { "update:options": _vm.onOptionsUpdate }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }